import React from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';

interface MobileErrorProps {
    mobileError: boolean;
}

interface MobileErrorState {
    mobileError: boolean;
}

class MobileError extends React.Component<MobileErrorProps, MobileErrorState> {
    constructor(props: MobileErrorProps) {
        super(props);
        this.state = {
            mobileError: false,
        };
    }

    static getDerivedStateFromProps(props: MobileErrorProps, state: MobileErrorState) {
        if (props.mobileError !== state.mobileError) {
            return {
                mobileError: props.mobileError,
            };
        }

        return null;
    }

    render() {
        return (
            <section className="items-center  visible   xsm:invisible  sm:invisible md:invisible   justify-center inset-0 flex fixed w-full h-full z-40 bg-white overflow-hidden  ">
                <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="relative">
                        <Image src="/static/images/mobile-error.png" className="mx-auto" alt="error" />
                        <blockquote className="mt-8">
                            <div className="max-w-3xl mx-auto text-center  leading-9 font-sm text-gray-900">
                                <p className="font-sm font-bold">{translate('Application error')}</p>
                                <p className="text-sm">
                                    {translate(
                                        'TransitAnalyst is not supported on mobile web browsers. Please access the application via a full desktop/laptop web browser.'
                                    )}
                                </p>
                            </div>
                        </blockquote>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(MobileError));
